<template>
  <div>
      <v-list class="text-center px-10" nav>
          <v-list-item class=" grey lighten-4" @click="restartDevice()">
              <v-list-item-icon>
                  <v-icon>power_settings_new</v-icon>
              </v-list-item-icon>
              <v-list-item-content >
                  Restart
              </v-list-item-content>
          </v-list-item>
          <v-list-item class="grey lighten-4" @click="resetDevice()">
              <v-list-item-icon>
                  <v-icon>settings_backup_restore</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                Reset
              </v-list-item-content>
          </v-list-item>
      </v-list>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {}
  },
  props: ['device'],
  computed: {

  },
  methods: {
    async restartDevice () {
      this.spinner(true)
      let value = {
        devices: [this.device.id],
        trigger: 'restart'
      }
      try {
        await this.triggerDevices(value)
        this.snackbar({ text: `${this.device.name} restart successful` })
      } catch (e) {
        this.snackbar({ text: `Restart Failed` })
      }
      this.spinner(false)
    },

    async resetDevice () {
      this.spinner(true)
      let value = {
        devices: [this.device.id],
        trigger: 'reset'

      }
      try {
        await this.triggerDevices(value)
        this.snackbar({ text: `${this.device.name} reset successful` })
      } catch (e) {
        this.snackbar({ text: `Reset Failed` })
      }
      this.spinner(false)
    },

    ...mapActions({
      triggerDevices: 'signage/TriggerDevice'
    })
  }
}
</script>

<style>

</style>
